import { useTheme } from "next-themes";

export function ThemeMeta() {
  const { resolvedTheme } = useTheme();

  return (
    <meta
      name="theme-color"
      content={resolvedTheme === "dark" ? "#0a0a0a" : "#ffffff"}
    />
  );
}
